import { SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";

export function MarketingShell({
  children,
  googleConfigured,
  demoAllowed,
  narrow = false,
  fullBleed = false,
}: {
  children: React.ReactNode;
  googleConfigured: boolean;
  demoAllowed: boolean;
  /** Centered auth-style content width */
  narrow?: boolean;
  /** Landing-style: children own their own max-width / padding */
  fullBleed?: boolean;
}) {
  const mainClass = fullBleed
    ? "relative w-full flex-1"
    : narrow
      ? "relative mx-auto flex w-full max-w-5xl flex-1 flex-col justify-center px-4 py-12 md:px-6"
      : "relative mx-auto w-full max-w-[90rem] flex-1 px-4 py-12 md:px-8 xl:px-10";

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <div
        className="landing-orb left-[-12%] top-10 h-80 w-80 bg-teal-300/55"
        aria-hidden
      />
      <div
        className="landing-orb right-[-10%] top-24 h-96 w-96 bg-cyan-200/45"
        aria-hidden
      />
      <div
        className="landing-orb bottom-24 left-1/4 h-72 w-72 bg-emerald-200/50"
        aria-hidden
      />
      <div
        className="landing-orb right-1/4 bottom-0 h-64 w-64 bg-slate-300/40"
        aria-hidden
      />

      <SiteHeader
        googleConfigured={googleConfigured}
        demoAllowed={demoAllowed}
      />

      <main className={mainClass}>{children}</main>

      <SiteFooter />
    </div>
  );
}
